import { render, staticRenderFns } from "./IncomingTenderVersionColumn.vue?vue&type=template&id=082f1965&"
import script from "./IncomingTenderVersionColumn.vue?vue&type=script&lang=js&"
export * from "./IncomingTenderVersionColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports